// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf4bcda5","732":"5180e51d","977":"fdb24810"}[chunkId] + ".chunk.js";
};